import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState = [
  {
    center: [ -0.612, 41.401 ],
    scale: 2200841
  }
];

export const viewsSlice = createSlice({
  name: 'views',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    addView: (state, action) => {
      const newView = action.payload;
      //console.log('estado', newView)

      const existingView = state.find(view =>
        view.center[0] == newView.center[0] &&
        view.center[1] == newView.center[1] &&
        view.scale == newView.scale);

      if (!existingView) {
        //console.log('no repetetido')
        state.push(action.payload);
      } else {
        //console.log('repetido')
      }

    },
    resetViews: (state) => initialState
  }
});

export const { addView, resetViews } = viewsSlice.actions;

export const views_state = (state) => state.views;

export default viewsSlice.reducer;
